#import '../../fragments/userProfile.fragment.graphql'

mutation updateProfile($data: UserProfileInput) {
  updateProfile(input: { data: $user }) {
    profile {
      ...UserProfileFragment
    }
  }
}
